import React from "react";
import { toast } from "react-toastify";
import { Button } from "src/Components";
import {
  editMarketTradeHour,
  getMarketTradeHourByType,
} from "src/Requests/marketTradeHour";
import { packetErrorHandler } from "src/Utils/requestUtils";

interface IProps {
  marketTradeHoursTypeId: number;
  onClose: () => void;
  onSuccess: () => void;
}

const normalizeToInput = (value?: string): string => {
  if (!value) return "";
  const parts = value.split(":");
  if (parts.length < 2) return "";
  return `${parts[0]}:${parts[1]}`;
};

const normalizeToApi = (value: string): string => {
  if (!value) return "";
  const parts = value.split(":");
  if (parts.length === 2) return `${value}:00`;
  return value;
};

const MarketTradeHourModal: React.FC<IProps> = ({
  marketTradeHoursTypeId,
  onClose,
  onSuccess,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [submitLoading, setSubmitLoading] = React.useState(false);
  const [marketName, setMarketName] = React.useState("");
  const [startTime, setStartTime] = React.useState("");
  const [endTime, setEndTime] = React.useState("");

  React.useEffect(() => {
    setLoading(true);
    getMarketTradeHourByType(marketTradeHoursTypeId)
      .then((resp) => {
        setMarketName(resp.marketTradeHoursTypeName || "");
        setStartTime(normalizeToInput(resp.startTime));
        setEndTime(normalizeToInput(resp.endTime));
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, [marketTradeHoursTypeId]);

  const submitHandler = () => {
    if (!startTime || !endTime) {
      toast.error("ساعت شروع و پایان الزامی است");
      return;
    }

    setSubmitLoading(true);
    editMarketTradeHour({
      marketTradeHoursTypeId,
      startTime: normalizeToApi(startTime),
      endTime: normalizeToApi(endTime),
    })
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onSuccess();
          return;
        }
        toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setSubmitLoading(false));
  };

  return (
    <div className="flex flex-col gap-4 p-4 min-h-[220px] min-w-[360px]">
      <div className="flex justify-between items-center pb-2 border-b">
        <h2 className="text-lg font-semibold">ویرایش ساعت معاملات</h2>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-24">درحال بارگذاری...</div>
      ) : (
        <>
          <div className="text-sm text-gray-700">{marketName}</div>

          <div className="flex flex-col gap-3">
            <label className="flex flex-col gap-1 text-sm">
              <span>ساعت شروع</span>
              <input
                type="time"
                step={1}
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                className="border border-gray-300 rounded px-3 py-2"
              />
            </label>

            <label className="flex flex-col gap-1 text-sm">
              <span>ساعت پایان</span>
              <input
                type="time"
                step={1}
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
                className="border border-gray-300 rounded px-3 py-2"
              />
            </label>
          </div>

          <div className="flex items-center justify-end gap-2 pt-2">
            <div className="w-24">
              <Button
                onClick={onClose}
                text="بستن"
                variant="outlined"
                className="!border-gray-400 !text-gray-700"
              />
            </div>
            <div className="w-24">
              <Button
                onClick={submitHandler}
                text="ثبت"
                variant="contained"
                loading={submitLoading}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default MarketTradeHourModal;
